import jwtDecode from 'jwt-decode';
import { setAuthenticated, setLocalLogout } from '../redux/slices/loginSlice'; // Adjust the import path as needed
// import { getRoleId, getRolePermission } from './RBAC';
import { LOGIN_STATUS, STORAGE_KEY } from './Constant';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getRole, getRolePermission } from './RBAC';
import { getRoleManagement } from '../services';
import { LoggedUserType } from '../models/GlobalModels';

export const getAccessedStatesnDistricts = async (userId: string, accessToken: string) => {
  try {
    const response = await getRoleManagement(userId, accessToken);
    if (response && response.data && response.status === 200) {
      return {
        accessedStates: response.data.accessedStates || [],
        accessedDistricts: response.data.accessedDistricts || [],
        userRole: response.data.userRole,
        employeeId: response.data.employeeId
      };
    }
    return {
      accessedStates: [],
      accessedDistricts: [],
      userRole: -1,
      employeeId: null
    };
  } catch (error) {
    console.error('Error fetching accessed states and districts:', error);
    return {
      accessedStates: [],
      accessedDistricts: [],
      userRole: -1,
      employeeId: null
    };
  }
};

export const refreshAuthToken = async (refreshToken: any) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/token`, new URLSearchParams({
      'client_id': process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? '',
      'client_secret': process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET ?? '',
      'grant_type': 'refresh_token',
      'refresh_token': refreshToken
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });

    const {candidateUniqueId, roleId, accessedStates, accessedDistricts} = JSON.parse((localStorage.getItem(STORAGE_KEY.AUTH_DATA) ?? ''));
    const newAccessToken = response.data.access_token;
    const tokenPayload = JSON.parse(atob(newAccessToken.split('.')[1]));
    const sessionId = tokenPayload.sid || tokenPayload.session_state || "";
    const roleData = getRole(tokenPayload.groups || []);
    const userId = tokenPayload?.sub || "";
    const email = tokenPayload.email || "";


    const updatedData: LoggedUserType = {
      candidateUniqueId: candidateUniqueId,
      employeeName: tokenPayload.name,
      emailId: tokenPayload.email,
      accessToken: newAccessToken,
      accessExpiryTime: tokenPayload.exp,
      resetToken: response.data.refresh_token,
      resetExpiryTime: tokenPayload.exp,
      permissions: getRolePermission(tokenPayload),
      roleId: roleId,
      roleName: roleData.groups,
      sessionId: sessionId,
      userId: userId,
      accessedStates: accessedStates,
      accessedDistricts: accessedDistricts
    };
    localStorage.setItem('chm-app-auth', JSON.stringify(updatedData));
    return newAccessToken;

  } catch (error) {
    console.error('Error refreshing token:', error);
    toast.error('Session expired')
    localStorage.clear();
    setLocalLogout({});
    // dispatch(setLocalLogout({}));
    window.location.href = '/';
  }
};

export const getAdminTokenApi = async () => {
    const response = await axios.post(`${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/token`, new URLSearchParams({
      'client_id': process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? '',
      'client_secret': process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET ?? '',
      'grant_type': 'client_credentials'
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });

    const token = response.data.access_token;
    const tokenPayload = JSON.parse(atob(token.split('.')[1]));
    const expiryTime = tokenPayload.exp;

    return {token: token, expiryTime: expiryTime};
  };


export const invalidateExistingSessions = async (userId: any, adminToken: any, currentSession: any) => {
    const sessionsResponse = await axios.get(`${process.env.REACT_APP_KEYCLOAK_URL}/admin/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/users/${userId}/sessions`, {
      headers: {
        'Authorization': `Bearer ${adminToken}`
      }
    });
  
    const sessions = sessionsResponse.data;
    const clientName = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
  
    for (const session of sessions) {
      const sessionClients = session?.clients || {};
      const clientIds = Object.keys(sessionClients);
  
      for (const clientId of clientIds) {
        if (sessionClients[clientId] === clientName && session?.id !== currentSession) {
          await axios.delete(`${process.env.REACT_APP_KEYCLOAK_URL}/admin/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/sessions/${session.id}`, {
            headers: {
              'Authorization': `Bearer ${adminToken}`
            }
          });
        }
      }
    }
  };

  export const getUserGroups = async (userId: string, adminToken: string) => {
    const response = await axios.get(`${process.env.REACT_APP_KEYCLOAK_URL}/admin/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/users/${userId}/groups`, {
      headers: {
        'Authorization': `Bearer ${adminToken}`,
      },
    });
    return response.data.map((group: any) => ({
      id: group.id,
      name: group.name,
      path: group.path,
      parentId: group.parentId,
    }));
  };


export  const getGroupByName = async (groupName: string, adminToken: string) => {
  const response = await axios.get(`${process.env.REACT_APP_KEYCLOAK_URL}/admin/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/groups`, {
    headers: {
      'Authorization': `Bearer ${adminToken}`,
    },
  });
  return response.data.find((group: any) => group.name === groupName);
};

export const getChildGroups = async (parentId: string, adminToken: string) => {
  let allChildGroups: any = [];
  let page = 0;
  const pageSize = 100; // Adjust this based on the API's limit

  while (true) {
    const response = await axios.get(`${process.env.REACT_APP_KEYCLOAK_URL}/admin/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/groups/${parentId}/children`, {
      headers: {
        'Authorization': `Bearer ${adminToken}`,
      },
      params: {
        first: page * pageSize,
        max: pageSize,
        fields: 'id,name,path,parentId', // Specify the fields you want
      },
    });

    const childGroups = response.data;
    allChildGroups = allChildGroups.concat(childGroups);

    if (childGroups.length < pageSize) {
      break; // No more pages to fetch
    }

    page++;
  }

  return allChildGroups;
};

export const assignUserToGroup = async (userId: string, groupId: string, adminToken: string) => {
  await axios.put(`${process.env.REACT_APP_KEYCLOAK_URL}/admin/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/users/${userId}/groups/${groupId}`, {}, {
    headers: {
      'Authorization': `Bearer ${adminToken}`,
    },
  });
};

export const getQCUsersFromKeycloak = async (adminToken: string) => {
  try {
    const qualityCheckerGroupId = process.env.REACT_APP_KEYCLOAK_QC_GROUP_ID;
    const response = await axios.get(`${process.env.REACT_APP_KEYCLOAK_URL}/admin/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/groups/${qualityCheckerGroupId}/members`, {
      headers: {
        'Authorization': `Bearer ${adminToken}`,
      },
      params: {
        first: 0,
        max: 1000,
      },
    });

    const qcUsers = response.data.map((user: any) => ({
      label: user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.username,
      value: user.id,
      email: user.email
    }));

    return qcUsers;
  } catch (error) {
    console.error('Error fetching QC users from Keycloak:', error);
    return [];
  }
};